import { Typography } from "@mui/material";
import React from "react";
import styled, { ThemeProvider } from "styled-components";
import theme from "../../../style/theme";
import { OutlineRoutePinProps } from "./outline-route-pin-props";

// interface OutlineRoutePinProps {
//   number: number;
//   id?: string;
//   backgroundColor: string;
//   borderColor: string;
//   color: string;
//   borderWidth: number;
//   rightLabel: string;
//   leftLabel: string;
//   positionStyle?: React.CSSProperties;
//   sx?: any;
// }

export const OutlineRoutePin: React.FC<OutlineRoutePinProps> = ({
  number,
  id,
  positionStyle,
  leftLabel,
  rightLabel,
  ...rest
}) => {
  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <OutlineRoutePinBox number={number} style={positionStyle}>
          <OutlineRooutePinRoot>
            <OutlineRoutePinItem {...rest}>{number}</OutlineRoutePinItem>
            <AddressBox className="address-box">
              <DeliveryTypeItem>{leftLabel}&nbsp;</DeliveryTypeItem>
              <AddressItem>{rightLabel}</AddressItem>
            </AddressBox>
          </OutlineRooutePinRoot>
        </OutlineRoutePinBox>
      </ThemeProvider>
    </React.Fragment>
  );
};

interface OutlineRoutePinBoxProps {
  number: number;
}

const OutlineRoutePinBox = styled.div<OutlineRoutePinBoxProps>`
  position: relative;
  z-index: ${(props) => 999 + Number(props.number)};
  &:hover {
    z-index: 9000;
  }
`;

const OutlineRooutePinRoot = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    & > .address-box {
      display: flex;
    }
  }
`;

const OutlineRoutePinItem = styled.button<any>`
  height: 32px;
  padding: 0px;
  display: inline-block;
  font-size: 16px;
  line-height: 19.2px;
  font-weight: 800;
  text-align: center;
  min-width: 32px;
  box-sizing: border-box;
  border-radius: 50%;
  border: ${(props) => `${props.borderWidth}px solid ${props.borderColor}`};
  color: ${(props) => props.color};
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
  background: ${(props) => `${props.backgroundColor}`};
  ${(props) => props.sx};
`;

const AddressBox = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 25px);
  display: none;
  align-items: center;
  background: white;
  padding: 4px 8px;
  border: 1px solid
    ${(props: any) => props.theme.palette.primitives["gray200"]};
  border-radius: 4px;
  width: max-content;
`;

const DeliveryTypeItem = styled(Typography)`
  font-size: 12px;
`;

const AddressItem = styled(Typography)`
  font-size: 12px;
  font-weight: bold;
`;
